import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { createCommissionsRequest, deleteCommissionsRequest, fetchCommissionsRequest, updateCommissionsRequest } from './requestHandlers';
import { ICommission, ICommissionData } from './types';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadCommissionsStart = createAction('commission/load/start');
export const loadCommissionsSuccess = createAction<ICommissionData>('commission/load/success');
export const resetCommissions = createAction('commission/reset');

export const loadCommissions = (commissionType: string, history: RouteComponentProps['history'], params: IQueryParams = {}) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch(loadCommissionsStart());
    const initialParams = qs.parse(history.location.search);
    const mergedParams = removeEmpty({ ...defaultParams, ...initialParams, ...params });
    const data = await fetchCommissionsRequest(commissionType, mergedParams);
    if (data) {
      dispatch(loadCommissionsSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const createCommission = (commissionType: string, id: string, data: Partial<ICommission>): Promise<ICommission | undefined> =>
  createCommissionsRequest(commissionType, id, data);

export const updateCommission = (commissionType: string, id: string, data: Partial<ICommission>): Promise<ICommission | undefined> =>
  updateCommissionsRequest(commissionType, id, data);

export const deleteCommission = (commissionType: string, id: string, commissionId: number): Promise<void> =>
  deleteCommissionsRequest(commissionType, id, commissionId);
